<template>
  <div class="block">
    <div class="block-title">小程序推广订单</div>

    <el-tabs v-model="orderStatus" @tab-click="changeOrderStatus">
      <el-tab-pane
        :label="item.name"
        v-for="(item, index) in orderStatusList"
        :name="item.value"
        :key="index"
      ></el-tab-pane>
    </el-tabs>

    <el-form :model="searchForm" class="search-form">
      <el-form-item label="订单号" prop="orderId">
        <el-input
          :maxlength="255"
          v-model.trim="searchForm.orderId"
          placeholder="请输入订单号"
        />
      </el-form-item>
      <el-form-item label="用户ID" prop="id">
        <el-input
          :maxlength="255"
          v-model.trim="searchForm.id"
          placeholder="请输入用户ID"
        />
      </el-form-item>

      <el-form-item label="手机号" prop="reservedPhone">
        <el-input
          :maxlength="255"
          v-model.trim="searchForm.reservedPhone"
          placeholder="请输入手机号"
        />
      </el-form-item>
      <el-form-item label="拦截状态">
        <el-select
          v-model="searchForm.interceptOrderStatus"
          placeholder="请选择拦截状态"
        >
          <el-option
            v-for="item in interceptList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="推广位名称">
        <el-select
          v-model="searchForm.promoteCode"
          placeholder="请选择推广位名称"
        >
          <el-option
            v-for="item in promoteCodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="下单日期" prop="orderCreateTime">
        <el-date-picker
          v-model="searchForm.orderCreateTime"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="changeOrderCreateTime"
          :clearable="false"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="是否优惠券订单">
        <el-select
          v-model="searchForm.couponTypeId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in optionsType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="订单类型">
        <el-radio-group
          v-model="searchForm.orderType"
          @change="changeOrderType"
        >
          <el-radio label="">全部</el-radio>
          <el-radio :label="1">特惠单</el-radio>
          <el-radio :label="3">快出单</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
        <el-button :loading="exportLoading" @click="onFormExport"
          >导出数据</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      header-row-class-name="header"
      border
      highlight-current-row
      row-key="id"
      :data="table.dataSource"
      v-loading="table.loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />

      <el-table-column label="订单ID" min-width="240" prop="orderId">
        <template slot-scope="{ row }">
          <order-detail :is-order="true" :row="row" />
          <div
            v-if="
              ['1', '2'].includes(row.miniAppType) &&
              row.thirdOrderId &&
              row.thirdOrderId.length
            "
          >
            第三方:{{ row.thirdOrderId }}
            <el-tag v-clipboard:copy="row.thirdOrderId" v-clipboard:success="onCopy" style="cursor: pointer;" size="mini">复制</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="120" prop="fansId">
      </el-table-column>
      <el-table-column label="手机号" min-width="120" prop="reservedPhone">
      </el-table-column>
      <el-table-column label="市场价（元）" min-width="110" prop="initPrice">
      </el-table-column>
      <el-table-column v-if="canShowAddPrice" width="110" prop="virtualAddPrice">
        <template #header>
          虚拟加价（元）
          <el-tooltip
            effect="dark"
            content="虚拟加价取的是开放前台配置的市场价加价"
            placement="top"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
      </el-table-column>>
      <el-table-column label="支付金额（元）" min-width="120" prop="payAmount">
      </el-table-column>
      <el-table-column
        label="订单总佣金（元）"
        min-width="140"
        prop="commission"
      >
      </el-table-column>
      <el-table-column
        min-width="120"
        prop="appCommission"
      >
        <template #header>
          我的佣金（元）
          <el-tooltip
            effect="dark"
            content="若出现支付价浮动，则说明该订单为快出单。"
            placement="top"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template slot-scope="{ row }">
          <el-tooltip placement="right">
            <div slot="content">
              套餐分润比例：{{ row.packageCommissionRate }}%
              <template v-if="![null, 0].includes(row.floatCommission)">
                <br />浮动溢价结算：{{ row.floatCommission > 0 ? "+" : ""
                }}{{ row.floatCommission }}
              </template>
              <template v-if="row.couponPrice && row.couponTypeId == 10"
                ><br />优惠券结算：{{ row.couponCommission }}</template
              >
              <template v-if="row.dyDarenSellPremium && row.couponPrice == 0"
                ><br />达人溢价结算：{{ row.dyDarenSellPremium }}</template
              >
              <template v-if="row.cheaperPriceBd !== '-'&& row.couponTypeId == 20 || row.couponTypeId == 21 "
                ><br />抖音券面额：{{ row.cheaperPriceBd }}</template
              >
              <template v-if="row.couponTypeId == 40"
              ><br />通兑券结算：{{ row.couponCommission }}</template
              >
              <template v-if="row.couponTypeId == 60"
              ><br />天猫券结算：{{ row.couponCommission }}</template
              >
              <template v-if="row.couponTypeId == 70"
              ><br />京东福利券结算：{{ row.couponCommission }}</template
              >
              <template v-if="row.couponTypeId == 80"
              ><br />抖音poi券结算：{{ row.couponCommission }}</template
              >
              <template v-if="row.payPriceFloat && Number(row.payPriceFloat) !== 0">
                <br/>
                支付价格浮动：{{ row.payPriceFloat }}
              </template>
            </div>
            <span class="color-blue color-blue__underline">{{
              row.appCommission
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="佣金比例" min-width="120" prop="commissionRate">
        <template slot-scope="{ row }"> {{ row.commissionRate }}% </template>
      </el-table-column>
      <el-table-column label="订单状态" min-width="120" prop="orderStatusStr">
      </el-table-column>
      <el-table-column
        label="创建时间"
        min-width="170"
        prop="orderCreateTimeStr"
      >
      </el-table-column>
      <el-table-column
        label="拦截状态"
        min-width="120"
        prop="interceptOrderStatusStr"
      >
      </el-table-column>
      <el-table-column
        label="接受调座"
        min-width="120"
        prop="acceptChangeSeatStr"
      >
      </el-table-column>
      <el-table-column
        label="出票时间"
        min-width="100"
        prop="ticketDurationStr"
      >
      </el-table-column>

      <el-table-column label="优惠券金额（元）" min-width="140" prop="cheaperPriceBd">
      </el-table-column>
      <el-table-column label="优惠券类型" min-width="120" prop="couponType">
      </el-table-column>
      <el-table-column label="优惠券承担者" min-width="120" prop="couponHolder">
      </el-table-column>
      <el-table-column label="影片名称" min-width="120" prop="movieName">
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="120"
        align="center"
        fixed="right"
      >
        <template slot-scope="{ row }">
          <order-detail :row="row" />
          <intercept-status :row="row" @refresh="refreshList" />
          <push-ticket :row="row" @refresh="refreshList" />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <el-pagination
      v-if="table.total"
      class="table-pagination"
      @size-change="onSizeChange"
      @current-change="onCurrentChange"
      :current-page.sync="pagination.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="table.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
import InterceptStatus from "../groupOrder/InterceptStatus";
import PushTicket from "../groupOrder/PushTicket";
import OrderDetail from "../groupOrder/OrderDetail";
const searchParams = {
  orderId: "", // 订单号
  id: "", // 用户ID
  reservedPhone: "", // 手机号
  interceptOrderStatus: "", // 拦截状态
  promoteCode: "", // 推广位名称
  orderCreateTime: [], // 默认时间选择框下单时间为7天
  orderType: 1, // 下单订单类型
  orderCreateStartTime: "",
  orderCreateEndTime: "",
  couponTypeId:'', //是否优惠券下单
};
export default {
  components: {
    InterceptStatus,
    OrderDetail,
    PushTicket,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const minTime = curDate - 89 * 24 * 3600 * 1000; // 90天
          const maxTime = curDate; // 昨天
          return time.getTime() > maxTime || time.getTime() < minTime;
        },
      },
      optionsType: [
        {
          label: '全部',
          value: ""
        },
        {
          label: '是',
          value: "1"
        }, {
          label: '否',
          value: "0"
        }
      ],
      orderStatusList: [
        {
          name: "全部",
          value: "-1",
        },
        {
          name: "待出票",
          value: "3",
        },
        {
          name: "已出票",
          value: "4",
        },
        {
          name: "已结算",
          value: "5",
        },
        {
          name: "已关闭",
          value: "10",
        },
      ],
      orderStatus: "-1", // 订单状态

      exportLoading: false, // 导出loading
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        selectRowsIds: [], // 选中数据
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      promoteCodeList: [
        // 推广位列表
      ],
      interceptList: [
        // 拦截状态
        {
          label: "全部",
          value: "",
        },
        {
          label: "未拦截",
          value: 0,
        },
        {
          label: "拦截中",
          value: 1,
        },
        {
          label: "拦截成功",
          value: 2,
        },
        {
          label: "拦截失败",
          value: 3,
        },
      ],
      miniAppType: localStorage.getItem("miniAppType"),
    };
  },
  computed:{
    canShowAddPrice() {
      return [0,5,3].includes(Number(this.miniAppType))
    }
  },
  mounted() {
    this.searchForm.orderCreateTime = [
      new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
      new Date(),
    ];
    // orderCreateTime日期格式转换为年月日
    this.searchForm.orderCreateTime = this.searchForm.orderCreateTime.map(
      (item) => {
        return this.formatDateHandel(item);
      }
    );
    this.searchForm.orderCreateStartTime =
      this.searchForm.orderCreateTime[0] + " 00:00:00";
    this.searchForm.orderCreateEndTime =
      this.searchForm.orderCreateTime[1] + " 23:59:59";
    this.freshTable();
    this.getPromoteList();
  },
  methods: {
    //复制
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
    formatDateHandel(date) {
      var year = date.getYear() + 1900; // getYear返回的是从1900年开始算起的年份，需加上1900
      var month = date.getMonth() + 1; // getMonth返回的是0-11，需要加1
      var day = date.getDate();

      // 格式化为yyyy-mm-dd格式
      var formattedDate =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      return formattedDate;
    },
    // 刷新列表
    refreshList() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    changeOrderType() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 序号
    indexMethod(index) {
      return (
        index + 1 + (this.pagination.pageNo - 1) * this.pagination.pageSize
      );
    },
    // 修改订单状态
    changeOrderStatus() {
      this.onFormReset();
    },
    // 获取推广位名称列表
    async getPromoteList() {
      const res = await MiniModel.getPromoteList({
        appKey: localStorage.getItem("appKeyMini"),
      });

      if (res.data.code === 200) {
        if (res.data.data && res.data.data.length) {
          this.promoteCodeList = res.data.data.map((item) => ({
            value: item.code,
            label: item.name,
          }));
          this.promoteCodeList.unshift({
            value: "",
            label: "全部",
          });
        }
      }
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.pagination.pageNo = 1;
          this.freshTable();
        },
        500,
        true
      );
    },
    // 表单重置
    onFormReset() {
      debounce(
        () => {
          this.searchForm = Object.assign({}, searchParams);
          this.pagination.pageSize = 10;
          this.pagination.pageNo = 1;
          this.freshTable();
        },
        500,
        true
      );
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 修改下单时间
    changeOrderCreateTime(arr) {
      if (arr && arr.length) {
        this.searchForm.orderCreateStartTime = arr[0] + " 00:00:00";
        this.searchForm.orderCreateEndTime = arr[1] + " 23:59:59";
      } else {
        this.searchForm.orderCreateStartTime = "";
        this.searchForm.orderCreateEndTime = "";
      }
    },

    // 请求表格·
    async freshTable() {
      this.table.loading = true;

      const params = {
        appKey: localStorage.getItem("appKeyMini"),
        entrance: 10,
        orderStatus: this.orderStatus === "-1" ? "" : this.orderStatus,
        ...this.searchForm,
        ...this.pagination,
      };
      delete params.orderCreateTime;

      const data = await MiniModel.getOrderList(params).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        let miniAppType = localStorage.getItem("miniAppType");
        this.table.dataSource = data.data.data.list.map((item) => {
          item.miniAppType = miniAppType;
          return {
            ...item,
            cheaperPriceBd: item.cheaperPriceBd ? item.cheaperPriceBd : "-",
            couponType: item.couponType ? item.couponType : "-",
            couponHolder: item.couponHolder ? item.couponHolder : "-",
            virtualAddPrice: item.virtualAddPrice !== null ? item.virtualAddPrice : "-",
          };
        });
        this.table.total = data.data.data.total;
      }
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
    onFormExport() {
      this.exportLoading = true;
      const params = {
        appKey: localStorage.getItem("appKeyMini"),
        entrance: 10,
        orderStatus: this.orderStatus === "-1" ? "" : this.orderStatus,
        ...this.searchForm,
      };
      MiniModel.exportMovieOrder(params).then(async res => {
        const code = res.data.code
        const message = res.data.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
      }).finally(()=>{
        this.exportLoading = false
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/order/index.vue